import React, { FC, PropsWithChildren } from "react";
import Button from "@laborhack/custom-button";

import styles from "./styles.module.scss";

export interface SignInButtonProps {
  onClick: () => void;
}

export const SignInButton = ({
  onClick,
  children,
}: PropsWithChildren<SignInButtonProps>) => {
  return (
    <Button className={styles.signInButton} onClick={onClick}>
      {children}
    </Button>
  );
};
